module.exports = __webpack_public_path__ + "img/icon-step@3x1.73c26974.png";